module.exports = __webpack_public_path__ + "static/media/soul-border.40aee1df.svg";